import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {
  Input
} from 'reactstrap'

class FieldHidden extends Component {
  constructor(props) {
    super(props)

    this.returnValue = this.returnValue.bind(this)
  }

  returnValue() {
    return this[this.props.cardField.id].value
  }

  render() {
    return <Input
            type={this.props.cardField.fieldType}
            key={this.props.cardField.id}
            id={this.props.cardField.id}
            defaultValue={this.props.cardField.fieldValue}
            required={this.props.cardField.fieldRequired}
            innerRef={el => { this[this.props.cardField.id] = el }}
        />
  }
}

FieldHidden.propTypes = {
  cardField: PropTypes.object,
  isEditing: PropTypes.bool,
  cardType: PropTypes.string
}

FieldHidden.defaultProps = {
  cardField: {
    cardSublabel: ''
  }
}

export default FieldHidden


// WEBPACK FOOTER //
// ./src/components/EditableCard/FieldHidden.js